export enum ActivitysTable {
  Lead = "Lead"
}
